module.exports = __webpack_public_path__ + "img/logo-white-small-space.a98699d3.png";